if (!customElements.get('ingredients-slides')) {
  customElements.define(
    'ingredients-slides',
    class IngredientsSlides extends HTMLElement {
      connectedCallback() {
        this.init();
      }

      init() {
        if (this.slider) return;

        this.slider = new Swiper(this.querySelector('.swiper'), {
          slidesPerView: 1,
          loop: true,
          observer: true,
          observeParents: true,
          updateOnWindowResize: true,
          speed: 600,
          allowTouchMove: false,

          autoplay: {
            delay: 2500,
            disableOnInteraction: false,
            pauseOnMouseEnter: false,
          },
        });
      }

      disconnectedCallback() {
        this.slider?.destroy(true, true);
      }
    }
  );
}